import { FC } from 'react'
import { SelectPicker, SelectPickerProps } from 'rsuite'
import './selectDropdown.scss'

interface Props extends SelectPickerProps<any> {
  lighter?: boolean
  form?: boolean
}

const SelectDropdown: FC<Props> = ({
  className,
  lighter,
  form,
  ...props
}: Props) => {
  const lighterClass = lighter ? 'lighter' : ''
  const formClass = form ? 'form' : ''
  return (
    <SelectPicker
      className={`select-picker ${className ?? ''} ${lighterClass} ${formClass}`}
      {...props}
    />
  )
}

export default SelectDropdown
